module.exports = __webpack_public_path__ + "img/icon-active-sensor.5602fec5.svg";